import { SET_SUBMITS_LOADING } from 'root/src/client/logic/form/actionIds'

export default payload => ({
	type: SET_SUBMITS_LOADING,
	payload,
})
